import { FC, useEffect } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router";

import { ERoutes } from "../../constants/routes";
import { LoginPayload } from "../../store/auth/types";
import Button from "../Button/Button";
import { loginUser } from "../../store/auth/slice";
import { selectAuthErrorLogin, selectAuthLoading } from "../../store/selectors/auth";
import FormikInputField from "../FormikField/FormikInputField/FormikInputField";
import { loginSchema } from "../../utils/validators";
import OAuthButton from "../OAuthButton/OAuthButton";
import AuthLayout from "../../layout/AuthLayout/AuthLayout";
import analytics from "../../lib/Analytics";

import styles from "./Login.module.css";



const Login: FC = () => {
  // Track page visit on mount
  useEffect(() => {
    analytics.track("Login page visited", {
      referrer: document.referrer || undefined,
    });
  }, []);
  const dispatch = useDispatch();
  const loading = useSelector(selectAuthLoading);
  const error = useSelector(selectAuthErrorLogin);

  const handleLogin = (values: LoginPayload) => {
    dispatch(loginUser(values));
  };

  return (
    <AuthLayout>
      <div className={styles["login"]}>

        <header className={styles["login__header"]}>
          <h1 className={styles["login__title"]}>Sign in to Your Account</h1>
        </header>


        <OAuthButton titleGoogle="Sign in with Google" titleMicrosoft="Sign in with Microsoft" isDisabled={loading} />

        <div className={styles["divider"]}>
          <hr />
          <span>Or</span>
          <hr />
        </div>

        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={loginSchema}
          onSubmit={(val) => handleLogin(val)}
        >
          {() => (
            <Form>
              <div className={styles["form__field"]}>
                <FormikInputField
                  placeholder="Email"
                  type="email"
                  name="email"
                  id="email"
                />
              </div>
              <div className={styles["form__field"]}>
                <FormikInputField
                  placeholder="Password"
                  type="password"
                  name="password"
                  id="password"
                />
              </div>

              <Link className={styles["form__link"]} to={ERoutes.ForgotPassword}>
                Forgot password?
              </Link>

              <Button
                size="lg"
                type="submit"
                className={styles["form__submit"]}
                disabled={loading}
                label="Continue"
                typeStyle="fill-auth"
              />

              {error && <div className={styles["form__error"]}>{error}</div>}
            </Form>
          )}
        </Formik>

        <footer className={styles["login__footer"]}>
          <p className={styles["login__caption"]}>Don't have an account yet? <Link to={ERoutes.Register}>Sign up</Link></p>
        </footer>

      </div>
    </AuthLayout>
  );
};

export default Login;
